import { useEffect } from "react";
// Importing for its side effect: registers window.__demoResolver so the network
// guard can serve rich demo data for modals/popovers while a demo is on screen.
import "./demoApi";

// While `active` is true, sets the global window.__demoMode flag that
// handleTokenAndPostRequest (src/utils/utils.js) checks before every request.
// This guarantees no demo interaction can reach the backend, and clears the
// flag on unmount or when the page leaves demo mode (e.g. real data arrives).
//
// One page renders per route, so a simple boolean is sufficient — there is no
// nesting of demo views to ref-count.
export default function useDemoNetworkGuard(active) {
  useEffect(() => {
    if (!active) return undefined;
    window.__demoMode = true;
    return () => {
      window.__demoMode = false;
    };
  }, [active]);
}
